<div class="d-flex">
  <!-- Priority 1: BroadcastName -->
  <ng-container *ngIf="params.data?.broadcastName != null">
    <a
      class="text-ul mr-1"
      [routerLink]="['/broadcast/edit', params.data?.broadcastId]"
      nz-tooltip
      [nzTooltipTitle]="params.data?.broadcastName"
    >
      <img
        src="./assets/images/sidebar/broadcast-selected.svg"
        alt="table-icon"
      />
    </a>
    <a
      class="text-ul text-ellipsis"
      [queryParams]="{ returnUrl: params.currentUrl }"
      [routerLink]="['/broadcast/edit', params.data?.broadcastId]"
    >
      {{ params.data?.broadcastName }}</a
    >
  </ng-container>

  <!-- Priority 2: SchedulerName (only if BroadcastName is not available) -->
  <ng-container *ngIf="params.data?.broadcastName == null && params.data?.schedulerName != null">
    <a
      class="text-ul mr-1"
      [routerLink]="['/scheduler/create']"
      [queryParams]="{ scheduleId: params.data?.schedulerId, scheduleName: params.data?.schedulerName, returnUrl: params.currentUrl }"
      nz-tooltip
      [nzTooltipTitle]="params.data?.schedulerName"
    >
      <img
        src="./assets/images/sidebar/scheduler-selected.svg"
        alt="table-icon"
      />
    </a>
    <a
      class="text-ul text-ellipsis"
      [routerLink]="['/scheduler/create']"
      [queryParams]="{ scheduleId: params.data?.schedulerId, scheduleName: params.data?.schedulerName, returnUrl: params.currentUrl }"
    >
      {{ params.data?.schedulerName }}</a
    >
  </ng-container>

  <!-- Priority 3: Layout — takes precedence over playlists (below broadcast/scheduler) -->
  <ng-container *ngIf="params.data?.broadcastName == null && params.data?.schedulerName == null && params.data?.layoutName != null">
    <a
      class="text-ul mr-1"
      [routerLink]="['/layouts/edit', params.data?.layoutId]"
      nz-tooltip
      [nzTooltipTitle]="params.data?.layoutName"
    >
      <img src="./assets/images/sidebar/layouts-selected.svg" alt="table-icon" />
    </a>
    <a
      class="text-ul text-ellipsis"
      [routerLink]="['/layouts/edit', params.data?.layoutId]"
    >
      {{ params.data?.layoutName }}</a
    >
  </ng-container>

  <!-- Priority 4: Single playlist — show name as link -->
  <ng-container *ngIf="params.data?.broadcastName == null && params.data?.schedulerName == null && params.data?.layoutName == null && params.data?.displayLists?.length === 1">
    <a
      class="text-ul mr-1"
      [routerLink]="['/display-list/edit', params.data?.displayLists[0]?.displayListId]"
      nz-tooltip
      [nzTooltipTitle]="params.data?.displayLists[0]?.name"
    >
      <img src="./assets/images/sidebar/playlist-selected.svg" alt="table-icon" />
    </a>
    <a
      class="text-ul text-ellipsis"
      [routerLink]="['/display-list/edit', params.data?.displayLists[0]?.displayListId]"
    >
      {{ params.data?.displayLists[0]?.name }}</a
    >
  </ng-container>

  <!-- Priority 5: Multiple playlists — count + chevron dropdown -->
  <ng-container *ngIf="params.data?.broadcastName == null && params.data?.schedulerName == null && params.data?.layoutName == null && params.data?.displayLists?.length > 1">
    <img src="./assets/images/sidebar/playlist-selected.svg" alt="table-icon" class="mr-1" />
    <a nz-dropdown [nzDropdownMenu]="playlistMenu" nzTrigger="click" class="text-ul d-flex align-items-center">
      {{ params.data?.displayLists?.length }} Playlists
      <span nz-icon nzType="down" nzTheme="outline" class="ml-1" style="font-size:10px;"></span>
    </a>
    <nz-dropdown-menu #playlistMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item *ngFor="let pl of params.data?.displayLists">
          <a [routerLink]="['/display-list/edit', pl.displayListId]" class="text-ul">
            {{ pl.name }}
          </a>
        </li>
      </ul>
    </nz-dropdown-menu>
  </ng-container>

  <!-- Show dash if nothing is available -->
  <span *ngIf="params.data?.broadcastName == null && params.data?.schedulerName == null && params.data?.layoutName == null && !(params.data?.displayLists?.length > 0)"
    >-</span
  >
</div>
